import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { VoiceContactData } from '../data-types/voice-data';
import { TwilioService } from '../services/twilio.service';

@Injectable({
    providedIn: 'root',
})
export class SearchActionsService {
    constructor(
        private router: Router,
        private twilioService: TwilioService,
        @Inject(DOCUMENT) private document: Document
    ) { }
    goToOrder(orderLine) {
        const url = this.router.createUrlTree(['/orders', orderLine.orderId]);
        window.open(url.toString(), '_blank');
    }
    goToAccount(account) {
        if (account.company) {
            const url = this.router.createUrlTree(['accounts', 'overview', account.accountType, account.company.id]);
            window.open(url.toString(), '_blank');
        } else {
            const url = this.router.createUrlTree(['accounts', 'overview', account.accountType, account.id]);
            window.open(url.toString(), '_blank');
        }
    }
    createOrderWithCustomer(customer: any) {
        const url = this.router.createUrlTree(['/order', 'create', 'customer-select'], {
            queryParams: {
                orderType: 'order',
                select_customer: customer.id,
            },
        });
        window.open(url.toString(), '_blank');
    }

    createQuoteWithCustomer(customer: any) {
        const url = this.router.createUrlTree(['/order', 'create', 'customer-select'], {
            queryParams: {
                orderType: 'quote',
                select_customer: customer.id,
            },
        });
        window.open(url.toString(), '_blank');
    }

    callAccount(customer: any) {
        const contact: VoiceContactData = {
            id: customer.id,
            accountType: customer.accountType,
            contactId: customer.id,
            contactFirstname: customer.contact.firstname,
            contactSurname: customer.contact.surname,
            contactMobile: customer.contact.mobile,
            contactLandline: customer.contact.landline,
            contactEmail: customer.username,
        };
        this.twilioService.startOutboundCall(customer.contact.mobile, contact);
    }
    startChat(customer: any) {
        this.router.navigate([
            '/mail',
            {
                compose2Id: customer.id,
                subject: '',
            },
        ]);
    }
    editProduct(product) {
        this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.router.navigate(['products', 'edit', product.slug]));
    }
    redirectToProductPublicView(product) {
        this.document.location.href = `${environment.publicSiteUrl}products/${product.slug}`;
    }
}
